import { getDirections } from '../../../services/directionsService';

// Current position -> destination distance/duration, shared by both flag-trip modals
// for their quoteFlagTrip mileage/durationSeconds inputs. Google Directions preferred
// (already loaded for the map); OSRM fallback via the app's own getDirections (which
// returns distance in meters, duration in seconds) — same free/self-hosted OSRM used
// elsewhere in this app, no paid API involved.
export async function computeMileageAndDuration(origin, dest, fleetSettings) {
  try {
    if (window.google?.maps?.DirectionsService) {
      const svc = new window.google.maps.DirectionsService();
      // Cap the Directions call so a hung/denied request can't freeze the modal
      // on "Checking…" — fall through to OSRM / a 0 result instead.
      const res = await Promise.race([
        svc.route({
          origin: { lat: origin.lat, lng: origin.lng },
          destination: { lat: dest.lat, lng: dest.lon },
          travelMode: window.google.maps.TravelMode.DRIVING,
        }),
        new Promise((_, reject) => setTimeout(() => reject(new Error('directions timeout')), 8000)),
      ]);
      const leg = res?.routes?.[0]?.legs?.[0];
      if (leg) {
        return {
          mileage: (leg.distance?.value || 0) / 1609.344,
          durationSeconds: leg.duration?.value || 0,
        };
      }
    }
  } catch (e) {
    /* fall through to OSRM */
  }
  try {
    const r = await getDirections({
      origin: { lat: origin.lat, lng: origin.lng },
      destination: { lat: dest.lat, lng: dest.lon },
      waypoints: [],
      osrmUrl: fleetSettings?.osrmUrl || fleetSettings?.osrmBaseUrl || fleetSettings?.OsrmBaseUrl || null,
    });
    if (r) {
      return { mileage: (r.distance || 0) / 1609.344, durationSeconds: r.duration || 0 };
    }
  } catch (e) {
    /* give up — server defaults dropoff to pickup + 15 min if duration is 0 */
  }
  return { mileage: 0, durationSeconds: 0 };
}

// The dispatch server sometimes relays a low-level parse error: its pricing handler
// received an HTML error page from an upstream pricing/routing service and tried to
// JSON.parse it (e.g. "Unexpected token < in JSON at position 4"). Show the driver
// something actionable instead of that raw developer text — the full payload is
// logged to the console for the backend team.
export function friendlyServerError(raw, fallback) {
  const msg = String(raw || '').trim();
  if (!msg) return fallback;
  if (/unexpected token|in json at position|<!doctype|<html|syntaxerror/i.test(msg)) {
    return 'Pricing is temporarily unavailable (server error). Please try again in a moment, or contact dispatch.';
  }
  return msg;
}
